import { render, staticRenderFns } from "./FormSectionWrap.vue?vue&type=template&id=ab2aced8&scoped=true"
import script from "./FormSectionWrap.vue?vue&type=script&lang=js"
export * from "./FormSectionWrap.vue?vue&type=script&lang=js"
import style0 from "./FormSectionWrap.vue?vue&type=style&index=0&id=ab2aced8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2aced8",
  null
  
)

export default component.exports